export default "__VITE_ASSET__0E3tkjC2__"